import React from 'react';
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import axios from "../axios";
import { Devices } from "../api/api";

import Dashboard from "../Dashboard";
import {
  Button,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from "@mui/material";

export default function DeviceRead() {
  const { id } = useParams<{
    id: string;
  }>();
  const navigation = useNavigate();

  const [data, setData] = useState<Devices>({});
  const [update, setUpdate] = useState<boolean>(false);

  useEffect(() => {
    axios.get("/devices/" + id).then((res) => {
      setData(res.data);
    });
  }, [id, update]);

  const handleEdit = () => {
    navigation("/devices/update/" + id);
  };

  const dateValue = (date: Date | undefined) => {
    if (date !== undefined) {
      return date!.toString().substring(0,19).replace('T', ' ');
    } else {
      return "";
    }
  };

  const booleanValue = (bool: boolean | undefined) => {
    switch (bool) {
      case undefined:
        return "false";
      case true:
        return "true";
      case false:
        return "false";
    }
  }

  return (
    <Dashboard title="デバイス管理">
      <Table>
        <TableBody>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>{data.id}</TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          <TableRow>
            <TableCell>デバイスID</TableCell>
            <TableCell>{data.device_id}</TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          <TableRow>
            <TableCell>サービスID</TableCell>
            <TableCell>{data.service_id}</TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          <TableRow>
            <TableCell>アプリID</TableCell>
            <TableCell>{data.app_id}</TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          <TableRow>
            <TableCell>アプリバージョン</TableCell>
            <TableCell>{data.app_version}</TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          <TableRow>
            <TableCell>アプリビルド番号</TableCell>
            <TableCell>{data.app_build_number}</TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          <TableRow>
            <TableCell>ICCID</TableCell>
            <TableCell>{data.iccid}</TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          <TableRow>
            <TableCell>IMEI</TableCell>
            <TableCell>{data.imei}</TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          <TableRow>
            <TableCell>IMSI</TableCell>
            <TableCell>{data.imsi}</TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          <TableRow>
            <TableCell>モデル名</TableCell>
            <TableCell>{data.model_name}</TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          <TableRow>
            <TableCell>OSバージョン</TableCell>
            <TableCell>{data.os_version}</TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          <TableRow>
            <TableCell>root権限</TableCell>
            <TableCell>{booleanValue(data.root_exploit)}</TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          <TableRow>
            <TableCell>キオスクモード</TableCell>
            <TableCell>{booleanValue(data.kiosk_mode_enabled)}</TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          <TableRow>
            <TableCell>デバイス有効</TableCell>
            <TableCell>{booleanValue(data.device_available)}</TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          <TableRow>
            <TableCell>サービス有効</TableCell>
            <TableCell>{booleanValue(data.service_available)}</TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          <TableRow>
            <TableCell>作成日時</TableCell>
            <TableCell>{dateValue(data.created_at)}</TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          <TableRow>
            <TableCell>更新日時</TableCell>
            <TableCell>{dateValue(data.updated_at)}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
      <br/>
      <Grid item xs={12}>
        <Button color="primary" variant="contained" onClick={handleEdit} sx={{ m: 1 }}>
          EDIT
        </Button>
      </Grid>
    </Dashboard>
  );
}
